export async function apiAuthLogout() {
  const apiResponse = {
    wasSuccessful: false
  }
  window.localStorage.removeItem('mainstem_user_token')
  apiResponse.wasSuccessful = true
  return apiResponse
}
